// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/attribute/v1/attribute.proto" (package "c1.api.attribute.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AttributeSearch } from "./attribute";
import type { SearchAttributeValuesResponse } from "./attribute";
import type { SearchAttributeValuesRequest } from "./attribute";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Attributes } from "./attribute";
import type { ListAttributeTypesResponse } from "./attribute";
import type { ListAttributeTypesRequest } from "./attribute";
import type { DeleteAttributeValueResponse } from "./attribute";
import type { DeleteAttributeValueRequest } from "./attribute";
import type { ListAttributeValuesResponse } from "./attribute";
import type { ListAttributeValuesRequest } from "./attribute";
import type { GetAttributeValuesResponse } from "./attribute";
import type { GetAttributeValuesRequest } from "./attribute";
import type { GetAttributeValueResponse } from "./attribute";
import type { GetAttributeValueRequest } from "./attribute";
import type { CreateAttributeValueResponse } from "./attribute";
import type { CreateAttributeValueRequest } from "./attribute";
import type { ListRiskLevelsResponse } from "./attribute";
import type { ListRiskLevelsRequest } from "./attribute";
import type { ListComplianceFrameworksResponse } from "./attribute";
import type { ListComplianceFrameworksRequest } from "./attribute";
import type { GetRiskLevelAttributeValueResponse } from "./attribute";
import type { GetRiskLevelAttributeValueRequest } from "./attribute";
import type { DeleteRiskLevelAttributeValueResponse } from "./attribute";
import type { DeleteRiskLevelAttributeValueRequest } from "./attribute";
import type { CreateRiskLevelAttributeValueResponse } from "./attribute";
import type { CreateRiskLevelAttributeValueRequest } from "./attribute";
import type { GetComplianceFrameworkAttributeValueResponse } from "./attribute";
import type { GetComplianceFrameworkAttributeValueRequest } from "./attribute";
import type { DeleteComplianceFrameworkAttributeValueResponse } from "./attribute";
import type { DeleteComplianceFrameworkAttributeValueRequest } from "./attribute";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateComplianceFrameworkAttributeValueResponse } from "./attribute";
import type { CreateComplianceFrameworkAttributeValueRequest } from "./attribute";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.attribute.v1.Attributes
 */
export interface IAttributesClient {
    /**
     * Create a compliance framework value.
     *
     * @generated from protobuf rpc: CreateComplianceFrameworkAttributeValue(c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest) returns (c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse);
     */
    createComplianceFrameworkAttributeValue(input: CreateComplianceFrameworkAttributeValueRequest, options?: RpcOptions): UnaryCall<CreateComplianceFrameworkAttributeValueRequest, CreateComplianceFrameworkAttributeValueResponse>;
    /**
     * Delete an attribute value by id.
     *
     * @generated from protobuf rpc: DeleteComplianceFrameworkAttributeValue(c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest) returns (c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse);
     */
    deleteComplianceFrameworkAttributeValue(input: DeleteComplianceFrameworkAttributeValueRequest, options?: RpcOptions): UnaryCall<DeleteComplianceFrameworkAttributeValueRequest, DeleteComplianceFrameworkAttributeValueResponse>;
    /**
     * Get an attribute value by id.
     *
     * @generated from protobuf rpc: GetComplianceFrameworkAttributeValue(c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest) returns (c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse);
     */
    getComplianceFrameworkAttributeValue(input: GetComplianceFrameworkAttributeValueRequest, options?: RpcOptions): UnaryCall<GetComplianceFrameworkAttributeValueRequest, GetComplianceFrameworkAttributeValueResponse>;
    /**
     * Create a risk level attribute.
     *
     * @generated from protobuf rpc: CreateRiskLevelAttributeValue(c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest) returns (c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse);
     */
    createRiskLevelAttributeValue(input: CreateRiskLevelAttributeValueRequest, options?: RpcOptions): UnaryCall<CreateRiskLevelAttributeValueRequest, CreateRiskLevelAttributeValueResponse>;
    /**
     * Delete a risk level attribute value by id.
     *
     * @generated from protobuf rpc: DeleteRiskLevelAttributeValue(c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest) returns (c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse);
     */
    deleteRiskLevelAttributeValue(input: DeleteRiskLevelAttributeValueRequest, options?: RpcOptions): UnaryCall<DeleteRiskLevelAttributeValueRequest, DeleteRiskLevelAttributeValueResponse>;
    /**
     * Get a risk level attribute value by id.
     *
     * @generated from protobuf rpc: GetRiskLevelAttributeValue(c1.api.attribute.v1.GetRiskLevelAttributeValueRequest) returns (c1.api.attribute.v1.GetRiskLevelAttributeValueResponse);
     */
    getRiskLevelAttributeValue(input: GetRiskLevelAttributeValueRequest, options?: RpcOptions): UnaryCall<GetRiskLevelAttributeValueRequest, GetRiskLevelAttributeValueResponse>;
    /**
     * @generated from protobuf rpc: ListComplianceFrameworks(c1.api.attribute.v1.ListComplianceFrameworksRequest) returns (c1.api.attribute.v1.ListComplianceFrameworksResponse);
     */
    listComplianceFrameworks(input: ListComplianceFrameworksRequest, options?: RpcOptions): UnaryCall<ListComplianceFrameworksRequest, ListComplianceFrameworksResponse>;
    /**
     * @generated from protobuf rpc: ListRiskLevels(c1.api.attribute.v1.ListRiskLevelsRequest) returns (c1.api.attribute.v1.ListRiskLevelsResponse);
     */
    listRiskLevels(input: ListRiskLevelsRequest, options?: RpcOptions): UnaryCall<ListRiskLevelsRequest, ListRiskLevelsResponse>;
    /**
     * Create a new attribute value.
     *
     * @generated from protobuf rpc: CreateAttributeValue(c1.api.attribute.v1.CreateAttributeValueRequest) returns (c1.api.attribute.v1.CreateAttributeValueResponse);
     */
    createAttributeValue(input: CreateAttributeValueRequest, options?: RpcOptions): UnaryCall<CreateAttributeValueRequest, CreateAttributeValueResponse>;
    /**
     * Get an attribute value by id.
     *
     * @generated from protobuf rpc: GetAttributeValue(c1.api.attribute.v1.GetAttributeValueRequest) returns (c1.api.attribute.v1.GetAttributeValueResponse);
     */
    getAttributeValue(input: GetAttributeValueRequest, options?: RpcOptions): UnaryCall<GetAttributeValueRequest, GetAttributeValueResponse>;
    /**
     * @generated from protobuf rpc: GetAttributeValues(c1.api.attribute.v1.GetAttributeValuesRequest) returns (c1.api.attribute.v1.GetAttributeValuesResponse);
     */
    getAttributeValues(input: GetAttributeValuesRequest, options?: RpcOptions): UnaryCall<GetAttributeValuesRequest, GetAttributeValuesResponse>;
    /**
     * List all attribute values for a given attribute type.
     *
     * @generated from protobuf rpc: ListAttributeValues(c1.api.attribute.v1.ListAttributeValuesRequest) returns (c1.api.attribute.v1.ListAttributeValuesResponse);
     */
    listAttributeValues(input: ListAttributeValuesRequest, options?: RpcOptions): UnaryCall<ListAttributeValuesRequest, ListAttributeValuesResponse>;
    /**
     * Delete an attribute value by id.
     *
     * @generated from protobuf rpc: DeleteAttributeValue(c1.api.attribute.v1.DeleteAttributeValueRequest) returns (c1.api.attribute.v1.DeleteAttributeValueResponse);
     */
    deleteAttributeValue(input: DeleteAttributeValueRequest, options?: RpcOptions): UnaryCall<DeleteAttributeValueRequest, DeleteAttributeValueResponse>;
    /**
     * List all attribute types.
     *
     * @generated from protobuf rpc: ListAttributeTypes(c1.api.attribute.v1.ListAttributeTypesRequest) returns (c1.api.attribute.v1.ListAttributeTypesResponse);
     */
    listAttributeTypes(input: ListAttributeTypesRequest, options?: RpcOptions): UnaryCall<ListAttributeTypesRequest, ListAttributeTypesResponse>;
}
/**
 * @generated from protobuf service c1.api.attribute.v1.Attributes
 */
export class AttributesClient implements IAttributesClient, ServiceInfo {
    typeName = Attributes.typeName;
    methods = Attributes.methods;
    options = Attributes.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Create a compliance framework value.
     *
     * @generated from protobuf rpc: CreateComplianceFrameworkAttributeValue(c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest) returns (c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse);
     */
    createComplianceFrameworkAttributeValue(input: CreateComplianceFrameworkAttributeValueRequest, options?: RpcOptions): UnaryCall<CreateComplianceFrameworkAttributeValueRequest, CreateComplianceFrameworkAttributeValueResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateComplianceFrameworkAttributeValueRequest, CreateComplianceFrameworkAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete an attribute value by id.
     *
     * @generated from protobuf rpc: DeleteComplianceFrameworkAttributeValue(c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest) returns (c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse);
     */
    deleteComplianceFrameworkAttributeValue(input: DeleteComplianceFrameworkAttributeValueRequest, options?: RpcOptions): UnaryCall<DeleteComplianceFrameworkAttributeValueRequest, DeleteComplianceFrameworkAttributeValueResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteComplianceFrameworkAttributeValueRequest, DeleteComplianceFrameworkAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get an attribute value by id.
     *
     * @generated from protobuf rpc: GetComplianceFrameworkAttributeValue(c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest) returns (c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse);
     */
    getComplianceFrameworkAttributeValue(input: GetComplianceFrameworkAttributeValueRequest, options?: RpcOptions): UnaryCall<GetComplianceFrameworkAttributeValueRequest, GetComplianceFrameworkAttributeValueResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetComplianceFrameworkAttributeValueRequest, GetComplianceFrameworkAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a risk level attribute.
     *
     * @generated from protobuf rpc: CreateRiskLevelAttributeValue(c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest) returns (c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse);
     */
    createRiskLevelAttributeValue(input: CreateRiskLevelAttributeValueRequest, options?: RpcOptions): UnaryCall<CreateRiskLevelAttributeValueRequest, CreateRiskLevelAttributeValueResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateRiskLevelAttributeValueRequest, CreateRiskLevelAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a risk level attribute value by id.
     *
     * @generated from protobuf rpc: DeleteRiskLevelAttributeValue(c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest) returns (c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse);
     */
    deleteRiskLevelAttributeValue(input: DeleteRiskLevelAttributeValueRequest, options?: RpcOptions): UnaryCall<DeleteRiskLevelAttributeValueRequest, DeleteRiskLevelAttributeValueResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRiskLevelAttributeValueRequest, DeleteRiskLevelAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a risk level attribute value by id.
     *
     * @generated from protobuf rpc: GetRiskLevelAttributeValue(c1.api.attribute.v1.GetRiskLevelAttributeValueRequest) returns (c1.api.attribute.v1.GetRiskLevelAttributeValueResponse);
     */
    getRiskLevelAttributeValue(input: GetRiskLevelAttributeValueRequest, options?: RpcOptions): UnaryCall<GetRiskLevelAttributeValueRequest, GetRiskLevelAttributeValueResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRiskLevelAttributeValueRequest, GetRiskLevelAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListComplianceFrameworks(c1.api.attribute.v1.ListComplianceFrameworksRequest) returns (c1.api.attribute.v1.ListComplianceFrameworksResponse);
     */
    listComplianceFrameworks(input: ListComplianceFrameworksRequest, options?: RpcOptions): UnaryCall<ListComplianceFrameworksRequest, ListComplianceFrameworksResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListComplianceFrameworksRequest, ListComplianceFrameworksResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListRiskLevels(c1.api.attribute.v1.ListRiskLevelsRequest) returns (c1.api.attribute.v1.ListRiskLevelsResponse);
     */
    listRiskLevels(input: ListRiskLevelsRequest, options?: RpcOptions): UnaryCall<ListRiskLevelsRequest, ListRiskLevelsResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRiskLevelsRequest, ListRiskLevelsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a new attribute value.
     *
     * @generated from protobuf rpc: CreateAttributeValue(c1.api.attribute.v1.CreateAttributeValueRequest) returns (c1.api.attribute.v1.CreateAttributeValueResponse);
     */
    createAttributeValue(input: CreateAttributeValueRequest, options?: RpcOptions): UnaryCall<CreateAttributeValueRequest, CreateAttributeValueResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAttributeValueRequest, CreateAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get an attribute value by id.
     *
     * @generated from protobuf rpc: GetAttributeValue(c1.api.attribute.v1.GetAttributeValueRequest) returns (c1.api.attribute.v1.GetAttributeValueResponse);
     */
    getAttributeValue(input: GetAttributeValueRequest, options?: RpcOptions): UnaryCall<GetAttributeValueRequest, GetAttributeValueResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAttributeValueRequest, GetAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAttributeValues(c1.api.attribute.v1.GetAttributeValuesRequest) returns (c1.api.attribute.v1.GetAttributeValuesResponse);
     */
    getAttributeValues(input: GetAttributeValuesRequest, options?: RpcOptions): UnaryCall<GetAttributeValuesRequest, GetAttributeValuesResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAttributeValuesRequest, GetAttributeValuesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all attribute values for a given attribute type.
     *
     * @generated from protobuf rpc: ListAttributeValues(c1.api.attribute.v1.ListAttributeValuesRequest) returns (c1.api.attribute.v1.ListAttributeValuesResponse);
     */
    listAttributeValues(input: ListAttributeValuesRequest, options?: RpcOptions): UnaryCall<ListAttributeValuesRequest, ListAttributeValuesResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAttributeValuesRequest, ListAttributeValuesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete an attribute value by id.
     *
     * @generated from protobuf rpc: DeleteAttributeValue(c1.api.attribute.v1.DeleteAttributeValueRequest) returns (c1.api.attribute.v1.DeleteAttributeValueResponse);
     */
    deleteAttributeValue(input: DeleteAttributeValueRequest, options?: RpcOptions): UnaryCall<DeleteAttributeValueRequest, DeleteAttributeValueResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAttributeValueRequest, DeleteAttributeValueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all attribute types.
     *
     * @generated from protobuf rpc: ListAttributeTypes(c1.api.attribute.v1.ListAttributeTypesRequest) returns (c1.api.attribute.v1.ListAttributeTypesResponse);
     */
    listAttributeTypes(input: ListAttributeTypesRequest, options?: RpcOptions): UnaryCall<ListAttributeTypesRequest, ListAttributeTypesResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAttributeTypesRequest, ListAttributeTypesResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.attribute.v1.AttributeSearch
 */
export interface IAttributeSearchClient {
    /**
     * Search attributes based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchAttributeValues(c1.api.attribute.v1.SearchAttributeValuesRequest) returns (c1.api.attribute.v1.SearchAttributeValuesResponse);
     */
    searchAttributeValues(input: SearchAttributeValuesRequest, options?: RpcOptions): UnaryCall<SearchAttributeValuesRequest, SearchAttributeValuesResponse>;
}
/**
 * @generated from protobuf service c1.api.attribute.v1.AttributeSearch
 */
export class AttributeSearchClient implements IAttributeSearchClient, ServiceInfo {
    typeName = AttributeSearch.typeName;
    methods = AttributeSearch.methods;
    options = AttributeSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search attributes based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchAttributeValues(c1.api.attribute.v1.SearchAttributeValuesRequest) returns (c1.api.attribute.v1.SearchAttributeValuesResponse);
     */
    searchAttributeValues(input: SearchAttributeValuesRequest, options?: RpcOptions): UnaryCall<SearchAttributeValuesRequest, SearchAttributeValuesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAttributeValuesRequest, SearchAttributeValuesResponse>("unary", this._transport, method, opt, input);
    }
}
